import { render } from "./EffectButton.vue?vue&type=template&id=430bcb9c&scoped=true"
import script from "./EffectButton.vue?vue&type=script&lang=js"
export * from "./EffectButton.vue?vue&type=script&lang=js"

import "./EffectButton.vue?vue&type=style&index=0&id=430bcb9c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-430bcb9c"

export default script